<template>
  <v-card class="pa-5 mb-5 elevation-hb">
    <v-row no-glutters align="center">
      <v-col>
        <h3 class="my-0">
          <v-icon>mdi-table-check</v-icon>
          ID Pedido: {{ id }}
        </h3>
      </v-col>
      <v-col class="text-right">
        <span title="Número Hubble" v-if="idHubble"> <b>ID Hubble:</b> #{{ idHubble }} </span>
        <span title="Número Seller" v-if="idSeller"> - <b>ID Seller:</b> #{{ idSeller }} </span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props:{
    id: String,
    idHubble: Number, 
    idSeller: String
  }
}
</script>

<style></style>
